import type { ParameterSet } from '@k-ucap/shared';
import type { ParameterSetRepository } from './RepositoryInterfaces.js';

const parameterSets: Map<string, ParameterSet> = new Map();

export class InMemoryParameterSetRepository implements ParameterSetRepository {
  async findAll(): Promise<ParameterSet[]> {
    return Array.from(parameterSets.values()).sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }

  async findById(id: string): Promise<ParameterSet | undefined> {
    return parameterSets.get(id);
  }

  async findByProjectId(projectId: string): Promise<ParameterSet[]> {
    return Array.from(parameterSets.values())
      .filter((p) => p.projectId === projectId)
      .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }

  async save(parameterSet: ParameterSet): Promise<ParameterSet> {
    parameterSets.set(parameterSet.id, parameterSet);
    return parameterSet;
  }

  async delete(id: string): Promise<void> {
    parameterSets.delete(id);
  }

  async duplicate(id: string, newName?: string): Promise<ParameterSet | undefined> {
    const original = await this.findById(id);
    if (!original) return undefined;
    const duplicated: ParameterSet = {
      ...original,
      id: `paramset-${Date.now()}`,
      name: newName ?? `${original.name} (Copy)`,
      parentId: original.id,
      revision: 1,
      updatedAt: new Date().toISOString(),
    };
    await this.save(duplicated);
    return duplicated;
  }
}

export const createInMemoryParameterSetRepository = (): InMemoryParameterSetRepository =>
  new InMemoryParameterSetRepository();
